const JT = {
    "1": "简体中文",
    "2": "繁体中文",
    "3": "英文",
    "4": "登录",
    "5": "ALL",
    "6": "新闻",
    "7": "比赛",
    "8": "活动",
    "9": "资讯",
    "10": "新店铺",
    "11": "新闻列表",
    "12": "店铺列表",
    "13": "店铺活动",
    "14": "产品展示",
    "15": "社交媒体",
    "16": "近期成绩",
    "17": "更改道具",
    "18": "退出",
    "19": "确定",
    "20": "我的页面首页",
    "21": "整体数据",
    "22": "游戏资料",
    "23": "主店",
    "24": "好友聊天",
    "25": "其他设定",
    "26": "账号",
    "27": "密码",
    "28": "忘记账号",
    "29": "忘记密码",
    "30": "注册新会员",
    "31": "国家/地區",
    "32": "语言",
    "33": "会员信息",
    "34": "ID",
    "35": "卡号",
    "36": "密码",
    "37": "确认密码",
    "38": "昵称",
    "39": "电子邮件",
    "40": "请输入6-20位英文字母或数字！",
    "41": "密码必须由6-20个字母组成！",
    "42": "使用电子邮件验证Adarts电子邮件地址！",
    "43": "必要的比赛信息",
    "44": "姓名",
    "45": "性别",
    "46": "SMS",
    "47": "出生日期",
    "48": "手机号码",
    "49": "若要参加Adarts举办得各种比赛，以下资料为必填",
    "50": "输入以下资料和确认电子邮件以接受您可以在机器上立即使用的风格道具",
    "51": "同意接受讯息",
    "52": "拒绝接受讯息",
    "53": "男",
    "54": "女",
    "55": "邮件设置",
    "56": "点击【注册】意味着您已同意Adarts的使用条款，并已阅读且理解包括cookie使用在内的个人资料政策",
    "57": "注册",
    "58": "忘记账号ID",
    "59": "发送验证码",
    "60": "Adarts账号密码",
    "61": "Adarts账号电子邮箱",
    "62": "Adarts账号ID",
    "63": "请输入正确的格式!",
    "64": "近30场成绩",
    "65": "Award记录",
    "66": "聊天内容",
    "67": "好友清单",
    "68": "新增好友",
    "69": "Adarts卡设定",
    "70": "账号信息设定",
    "71": "Award消息设定",
    "72": "道具设定",
    "73": "密码设定",
    "74": "Bull 数量",
    "75": "01总游戏数量/胜率",
    "76": "Cricket总游戏数量/胜率",
    "77": "总游戏数量/胜率",
    "78": "Count Up平均分数",
    "79": "Count Up最高分数",
    "80": "最高分数",
    "81": "Bull 击中率",
    "82": "S-Bull 击中率",
    "83": "D-Bull 击中率",
    "84": "Triple 击中率",
    "85": "01 最快结标标数",
    "86": "请输入用户名！",
    "87": "请输入密码！",
    "88": "验证码",
    "89": "请输入验证码！",
    "90": "请输入邮箱！",
    "91": "请输入账号！",
    "92": "全部",
    "93": "好友",
    "94": "密友",
    "95": "操作",
    "96": "复制卡",
    "97": "删除",
    "98": "添加卡",
    "99": "(国家/地区)/语言",
    "100": "卡登记日期",
    "101": "设定主题",
    "102": "图像",
    "103": "如您已登记各种类型AWARD信息，比赛中在飞镖机上刷 Adarts 线上卡时您的信息将在各AWARD时展示",
    "104": "AWARD信息",
    "105": "信息",
    "106": "AWARD",
    "107": "您可在此页面更改密码。此处更改的密码将用于卡ID及账号ID",
    "108": '旧密码',
    "109": '新密码',
    "110": '两次密码不一致！',
    "111": 'Adarts店铺主页',
    "112": 'Adarts搜索店铺',
    "113": '已设置主题店铺',
    "114": '最新店铺',
    "115": '选择区域',
    "116": '今日游戏资料',
    "117": '推荐',
    "118": '玩家清单',
    "119": '排名',
    "120": '搜索店铺',
    "121": '客服支援',
    "122": '7日内对战选手',
    "123": '新增',
    "124": '接受',
    "125": '复制成功',
    "126": '确认删除？',
    "127": '取消',
    "128": '本月',
    "129": '次数',
    "130": '请登录之后查看！',
    "131": '验证',
    "132": '暂无数据',
    "133": '倒计时：',
    "134": '请输入新密码',
    "135": '我的页面',
    "136": '道具商城',
    "137": 'Adarts店铺',
    "138": '任务奖励',
    "139": '选手介绍',
    "140": '飞镖规格',
    "141": '大赛成绩',
    "142": '选手影片',
    "143": '关联商品',
    "144": '设为主卡',
    "145": 'A1',
    "146": 'W1',
    "147": '查看地图',
    "148": '主题Style',
    "149": '营业时间',
    "150": '休息日',
    "151": '地址',
    "152": '交通资讯',
    "153": '预算',
    "154": '主题',
    "155": '服务',
    "156": '网址',
    "157": '比赛排名',
    "158": '道具商店',
    "159": '飞镖专栏',
    "160": '来自店铺的信息',
    "161": '主卡',
    "162": '主页',
    "163": '我的ITEM',
    "164": 'ITEM购买',
    "165": 'ITEM商店索引',
    "166": '我的设定',
    "167": '我的ITEM LIST',
    "168": '兑换道具',
    "169": '推荐ITEM',
    "170": '新ITEM',
    "171": '排名ITEM',
    "172": '道具兑换为金币',
    "173": '选择模板',
    "174": '保存设定',
    "175": 'Style设定',
    "176": '使用中的Item',
    "177": 'Award 設定',
    "178": '续期',
    "179": '所选道具',
    "180": '道具的使用期延长后，您将无法取消！',
    "181": '兑换金币数量',
    "182": '当前金币数量',
    "183": '合计金币数量',
    "184": '道具详细信息',
    "185": '拥有的金币',
    "186": '赠送礼品',
    "187": '索要礼品',
    "188": '是否购买',
    "189": '购买并应用',
    "190": '购买',
    "191": '什么是GOLD？',
    "192": 'GOLD的获取方法',
    "193": '什么是Item Shop？',
    "194": 'Gold Item 分类 & Item 种类',
    "195": '购买Item & Custom(Item设定与取消)',
    "196": '最近对战对手',
    "197": '选择',
    "198": '最后游玩时间(天)',
    "199": '已发送好友请求',
    "200": 'AWARD排名',
    "201": '进行中',
    "202": '已结束',
    "203": '举办店铺',
    "204": '活动日期',
    "205": '飞镖机',
    "206": '参加方法',
    "207": '联系方式',
    "208": '比赛时间',
    "209": '请求礼物',
    "210": '活动描述',
    "211": '参赛方法',
    "212": '参赛费用',
    "213": '报名费',
    "214": '奖励',
    "215": '其它',
    "216": '未开始',
    "217": '礼物盒',
    "218": '已收到得礼物',
    "219": '已收到得礼物请求',
    "220": '赠送好友',
    "221": '赠送时间',
    "222": '全部接受',
    "223": '依购买时间排序排列',
    "224": '依购买时间倒序排列',
    "225": '※ Item 下面得日期为购买日期',
    "226": '扣除的金币',
    "227": '最多储存10个模板',
    "228": '若您想要保存另外模板時，請在模板选择中，刪除不必要的模板',
    "229": '请输入模板名称',
    "230": '不使用模板',
    "231": '同意',
    "232": '拒绝',
    "233": '请求时间',
    "234": '店铺类型',
    "235": '最高连胜',
    "236": '日语',
    "237": '请输入新卡号',
    "238": '请使用全新卡进行卡复制功能，复制后，原卡将无法使用',
    "239": '发送',
    "240": '忘记账号或密码',
};
export default JT;